import axios from 'axios';
import type { CallImpactResponse } from '../types';

const BASE_URL = 'https://cp-voice-agent.clickpe.ai:9010';

/**
 * Stage options for the voice AI call impact API.
 * Add new stage values here as needed — they will appear in the dropdown.
 */
export const STAGE_OPTIONS: { label: string; value: string }[] = [
  { label: 'Lead Qualification', value: 'lead_qualification' },
  { label: 'Muthoot Loan', value: 'muthoot_loan' },
  { label: 'Pre Approved Loan', value: 'pre_approved' }
];

export const DEFAULT_STAGE = 'lead_qualification';

export async function fetchCallImpactData(
  startDate: string,
  endDate: string,
  stage: string = DEFAULT_STAGE
): Promise<CallImpactResponse> {
  // const agentId = localStorage.getItem('agent_id') || localStorage.getItem('agentId') || '';
  const response = await axios.get<CallImpactResponse>(
    `${BASE_URL}/get-voice-ai-call-impact`,
    {
      params: {
        start_date: startDate,
        end_date: endDate,
        stage
      },
    }
  );
  return response.data;
}
